
import { mapGetters,mapActions } from 'vuex'
export default {
  name: 'CourseRightForYou',
  data() {
    return {
      openFaqs: [1],
      benefits: [
        {
          id: 1,
          title: 'No Degree Required',
          description: "Just finished school? Looking to switch careers? This course is open to anyone – get globally recognised certification without a degree."
        },
        {
          id: 2,
          title: 'No Teaching Experience Needed',
          description: "Never taught before? No problem. We'll walk you through it all - from classroom basics to lesson planning – with support at every step."
        },
        {
          id: 3,
          title: "Not Academic? That's OK!",
          description: "Our courses and training are clear, engaging, and easy to follow – even if you haven't studied in a while."
        },
        {
          id: 4,
          title: 'Open to All Ages',
          description: "It's never too early, or too late, to start your TEFL journey. We've trained students from 18 to 80+ from around the world."
        },
        {
          id: 5,
          title: "Good English Skills? You're Good to Go",
          description: "You don't need to be a native speaker. If you have a strong grasp of English, we'll help you build the skills to teach it confidently."
        }
      ],
      faqs: [
        {
          id: 1,
          number: '01',
          question: '"I don\'t have any teaching experience..."',
          answer: 'Many of our graduates started from scratch. With our practical training and tutor support, they now teach confidently online and abroad.'
        },
        {
          id: 2,
          number: '02',
          question: '"I don\'t have a degree..."',
          answer: 'No degree is required for this course. Our TEFL certification is recognised worldwide and many schools accept TEFL qualified teachers without a university degree.'
        },
        {
          id: 3,
          number: '03',
          question: '"I\'m not a native English speaker..."',
          answer: 'You don\'t need to be a native speaker to teach English. As long as you have a strong command of English, you can successfully complete our course and teach worldwide.'
        },
        {
          id: 4,
          number: '04',
          question: '"I\'m over 50..."',
          answer: 'Age is no barrier to teaching English abroad or online. We\'ve trained thousands of students over 50 who have gone on to successful teaching careers around the world.'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      activeModal : 'pages/getActiveModal',
    }),
  },
  methods: {
    ...mapActions({
      updateActiveModal: 'pages/updateActiveModal',
    }),
    updateModal(id){
      this.updateActiveModal(id)
      console.log('Active Modal: ',this.activeModal)
    },
    toggleFaq(faqId) {
      const index = this.openFaqs.indexOf(faqId)
      if (index > -1) {
        this.openFaqs.splice(index, 1)
      } else {
        this.openFaqs.push(faqId)
      }
    }
  }
}
